import type { FC, SVGProps } from 'react';

export const CheckIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="22"
    height="22"
    fill="currentColor"
    viewBox="0 0 22 22"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fill="currentColor"
      d="M20.8228 3.09375C20.9871 3.09392 21.0777 3.28304 20.9771 3.4082L8.98486 18.6045C8.66812 19.002 8.06475 19.002 7.75049 18.6045L1.0249 10.084C0.924687 9.95643 1.01511 9.76794 1.1792 9.76758H2.896C3.01467 9.76773 3.13204 9.7948 3.23877 9.84668C3.34542 9.89856 3.43882 9.97421 3.51221 10.0674L8.3667 16.2178L18.4897 3.39355C18.637 3.20457 18.8654 3.09384 19.106 3.09375H20.8228Z"
    />
  </svg>
);
